import { render, staticRenderFns } from "./ColumnsManage.vue?vue&type=template&id=c2f65236&scoped=true&"
import script from "./ColumnsManage.vue?vue&type=script&setup=true&lang=js&"
export * from "./ColumnsManage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f65236",
  null
  
)

export default component.exports